//#region Imports
import { MultiColumnLayout } from "../config/layout";
import type { DeepReadonlyT } from "../utils/types-utils";
import type { DefaultViewType, IsoWeekdayT } from "./types";
//#endregion

//#region Private utilties
type NonNullableObjectT<T> = {
  [K in keyof T]: NonNullable<T[K]>;
};
//#endregion

export interface IUserSettingsRecord {
  theme: UserSettingsTheme;
  language: string;
  selectedImage: string;
  selectedImageDark: string;
  dateFormat: UserSettingsRecordDateFormat | null;
  timeFormat: UserSettingsRecordTimeFormat | null;
  googleCalendarDisabledCalendars: string;
  addedFirstMyDayEntry: boolean;
  macStoreRateUsLastInvocationTimestamp: number;
  isStickyMyDayVideoDismissed: boolean;
  isStickyBoardVideoDismissed: boolean;
  isStickyCardVideoDismissed: boolean;
  isStickyCopyInviteLinkDismissed: boolean;
  isStickyConnectWhatsAppTeamsDismissed: boolean;
  isCreateWorkspaceBannerDismissed: boolean;
  isScheduleOnboardingSessionDismissed: boolean;
  isOnboardingTourDismissed: boolean;
  hasSeenCustomFieldsTutorial: boolean;
  allMyTasksEntityType: "task" | "card";
  nextSevenDaysEntityType: "task" | "card";
  showMulticolumnOverdue: boolean;
  showMulticolumnChecked: boolean;
  multicolumnLayout: MultiColumnLayout;
  personalAiFeaturesConsent: boolean;
  defaultView: DefaultViewType;
  defaultViewLastViewed: Exclude<DefaultViewType, "lastviewed">;
  cardActivityChatOnly: boolean;
  showWeekend: boolean;
  fcmTokens: readonly string[];
  collapsedSidebarSections: Record<string, boolean>;
  isBoardAutomationsWelcomeScreenDismissed: boolean;
  isFormsWelcomeScreenDismissed: boolean;
  dismissedSmartCards: readonly string[];
  smartTypeTimeDetection: boolean;
}

export interface IReadonlyUserSettingsRecord extends DeepReadonlyT<IUserSettingsRecord> {}

export interface IFullUserSettingsRecord extends NonNullableObjectT<IUserSettingsRecord> {
  isoWeekStartDay: IsoWeekdayT;
}

export interface IReadonlyFullUserSettingsRecord extends DeepReadonlyT<IFullUserSettingsRecord> {}

export enum UserSettingsRecordSelectedImage {
  NONE = "NONE",
  BLANK = "BLANK",
  IMAGE_1 = "1",
  // IMAGE_2 = "2", // deprecated (Sacha)
  // IMAGE_3 = "3", // deprecated
  // IMAGE_4 = "4", // deprecated
  IMAGE_5 = "5",
  // IMAGE_6 = "6", // deprecated
  // IMAGE_7 = "7", // deprecated
  IMAGE_8 = "8",
  IMAGE_9 = "9",
  IMAGE_10 = "10",
  IMAGE_11 = "11",
  // IMAGE_12 = "12", // deprecated
  // IMAGE_13 = "13", // deprecated (Sacha)
  IMAGE_14 = "14",
  IMAGE_15 = "15",
  IMAGE_16 = "16",
  IMAGE_17 = "17",
  // IMAGE_18 = "18", // deprecated
  // IMAGE_19 = "19", // deprecated (Sacha)
  // New images (no number 20)
  IMAGE_21 = "21",
  IMAGE_22 = "22",
  IMAGE_23 = "23",
  IMAGE_24 = "24",
  IMAGE_25 = "25",
  IMAGE_26 = "26",
  IMAGE_27 = "27",
  IMAGE_28 = "28",
  IMAGE_29 = "29",
  IMAGE_30 = "30",
  IMAGE_31 = "31",
  IMAGE_32 = "32",
  IMAGE_33 = "33",
  IMAGE_34 = "34",
  IMAGE_35 = "35",
  IMAGE_36 = "36",
  IMAGE_37 = "37",
}

export type CustomBackgroundImage =
  | {
      source: "bundled";
      uid: string;
      value: UserSettingsRecordSelectedImage;
    }
  | {
      source: "unsplash";
      uid: string;
      id: string;
      url: string;
      color: string;
    };

export enum UserSettingsRecordDateFormat {
  MM_DD_YY = 0, // (Default)
  DD_MM_YY = 1,
}

export enum UserSettingsRecordTimeFormat {
  CLOCK_12 = 0, // (Default)
  CLOCK_24 = 1,
}

export enum UserSettingsTheme {
  AUTO = 0, // (Default)
  LIGHT = 1,
  DARK = 2,
}
